export default __webpack_public_path__ + "static/media/ss1.a318c965.JPG";